<template>
  <nx-relation-card-collapsed :title="name"
                              draggable
                              :icon="icon"
                              :image="imageUrl"
                              v-on="$listeners">
    <template slot="actions">
      <slot name="actions"></slot>
    </template>
  </nx-relation-card-collapsed>
</template>
<script>
import NxRelationCardCollapsed from '@/modules/relation/card/CardCollapsed';

export default {
  name: 'nx-scrollytelling-slide-multimedia-list-item',
  components: { NxRelationCardCollapsed },
  props: {
    name: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
    },
  },
  computed: {
    imageUrl() {
      if (this.image && this.image.mimeType.includes('image')) {
        return this.image.publicUrl;
      }

      return '';
    },
    icon() {
      if (!this.image || !this.image.mimeType.includes('image')) {
        return 'smart_display';
      }
      return null;
    },
  },
};
</script>
